var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.partnership)?_c('div',{staticClass:"network-partnership"},[_c('p',{staticClass:"network-partnership__text"},[_vm._v(_vm._s(_vm.partnership.text))]),_c('img',{staticClass:"network-partnership__logo",attrs:{"src":_vm.partnership.logoUrl,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }